import { GetBccEmails } from '@/connection/emails/bcc-emails';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelSettingsReducerCreator } from '../types';

const getBccEmailsReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async ({ channel }: { channel: number }, { rejectWithValue }) => {
      try {
        const bccEmails = await GetBccEmails({ channel });
        return bccEmails;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        state.bccEmails = action.payload.emails;
      },
    }
  );
};

export default getBccEmailsReducer;
